import { styled } from '@mui/material'
import DefaultPainel from '../../../components/shared/Painel'
const StyledDP = styled(DefaultPainel)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    minHeight: '70vh',
    height: '100%'
  },
  [theme.breakpoints.up('lg')]: {
    minHeight: '50vh',
    height: '100%'
  },
  [theme.breakpoints.up('xl')]: {
    minHeight: '50vh',
    height: '100%'
  }
}))

export default StyledDP
